import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import BaccaratResultBody from '../../../casinoComponents/refResultModal/BaccaratResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

// Reference titles (lastresults2 g.cname) per game type
const TITLES = { baccarat: 'Baccarat', baccarat2: 'Baccarat 2', pbaccarat: 'Premium Baccarat' };

/**
 * Last Result items for baccarat / baccarat2 / pbaccarat in the reference markup
 * (rendered inside CasinoLastResult's .casino-video-last-results):
 *   win 1 → span.resulta "P", 2 → span.resultb "B", 3 → span.resulttie "T".
 * Click → .loader-overlay (in .page-content) while the round detail loads, then RefResultModal.
 */
const ResultBaccarat = ({ data = [], gameType = 'baccarat' }) => {
  const apiType = (gameType || 'baccarat').toLowerCase().trim();
  const [showModal, setShowModal] = useState(false);
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        if (response?.success && response?.data?.data?.res) {
          setLastResults(response.data.data.res);
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };

    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [apiType]);

  const handleResultClick = async (resultItem) => {
    const mid = resultItem?.mid;
    if (!mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, mid.toString());
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) setDetailResult(t1);
    } catch (error) {
      console.error('Error fetching detail results:', error);
    }
    setLoading(false);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  const allResults = lastResults.length > 0
    ? lastResults
    : data.map((res) => ({ win: res === 'A' || res === 'P' ? '1' : res === 'T' ? '3' : '2', mid: null }));

  return (
    <>
      {allResults.map((resultItem, index) => {
        const win = String(resultItem.win);
        const cls = win === '1' ? 'resulta' : win === '2' ? 'resultb' : win === '3' ? 'resulttie' : undefined;
        return (
          <span key={index} className={cls} onClick={() => handleResultClick(resultItem)}>
            {win === '1' ? 'P' : win === '2' || win === '4' ? 'B' : 'T'}
          </span>
        );
      })}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title={`${TITLES[apiType] || detailResult?.ename || 'Baccarat'} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        <BaccaratResultBody t1={detailResult} gameType={apiType} />
      </RefResultModal>
    </>
  );
};

export default ResultBaccarat;
